import { LOGIN_DETAILS } from './types'

export const loginDetails = (details) => {
  return {
    type: LOGIN_DETAILS,
    payload: details,
  }
}
